export const roundOff = (num: number, precision: number) => {
  const anchor = Math.pow(10, precision)
  return Math.round(num * anchor) / anchor;
};
